'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.messages = messages;

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _messages = require('../actions/messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 */
var initialState = {};

/**
 *
 */
var add = function add(state, _ref, _ref2) {
	var messagesList = _ref.messagesList;
	var discussionId = _ref2.discussionId;
	return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, discussionId, {
		$apply: function $apply() {
			var messages = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
			return messages.concat(messagesList);
		}
	}));
};

/**
 *
 */
var initialize = function initialize(state, _ref3) {
	var messagesList = _ref3.messagesList;
	var discussionId = _ref3.discussionId;
	return (0, _reactAddonsUpdate2.default)(state, _defineProperty({}, discussionId, {
		$set: messagesList
	}));
};

/**
 *
 */
function messages() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var _ref4 = arguments[1];
	var type = _ref4.type;
	var payload = _ref4.payload;
	var meta = _ref4.meta;

	switch (type) {
		case _messages.ADD:
			return add(state, payload, meta);

		case _messages.INITIALIZE:
			return initialize(state, payload);

		default:
			return state;
	}
}